import { SET_HERO_HEIGHT, SET_MODIFY_INTAKE_HEIGHT, SET_INTAKE_HEIGHT, SET_INTAKE_HISTORY_HEIGHT } from "./actionTypes";

export const setHeroHeight = (height) => {
  return {
    type: SET_HERO_HEIGHT,
    payload: height,
  };
};

export const setModifyIntakeHeight = (height) => {
  return {
    type: SET_MODIFY_INTAKE_HEIGHT,
    payload: height,
  };
};

export const setIntakeHeight = (height) => {
  return {
    type: SET_INTAKE_HEIGHT,
    payload: height,
  };
};

export const setIntakeHistoryHeight = (height) => {
  return {
    type: SET_INTAKE_HISTORY_HEIGHT,
    payload: height,
  };
};
